module.exports = __webpack_public_path__ + "img/yahoo.dd6ce5a5.svg";